import { SelectorBoxFileStateType, } from '@kubit/web-ui-components/selectorBoxFile/types';
import { TextDecorationType } from '@kubit/web-ui-components/text/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
import { KubitSelectorBoxFileVariantType } from './variants';
const buildContainerBoxCommonProps = (FOUNDATIONS, FONT) => ({
    animationContainer: {
        padding: FOUNDATIONS.spacing_25,
        border: 'none',
        border_radius: FOUNDATIONS.radius_250,
        position: 'relative',
        overflow: 'hidden',
    },
    topAnimationContainer: {
        height: FOUNDATIONS.spacing_250,
        width: '0%',
        top: '0px',
        left: '25px',
        transition: '500ms width',
        position: 'absolute',
        background: FOUNDATIONS.color_accent_loading_secondary_border_50,
    },
    bottomAnimationContainer: {
        height: FOUNDATIONS.spacing_250,
        width: '0%',
        right: '0px',
        bottom: '0px',
        transition: '500ms width',
        position: 'absolute',
        background: FOUNDATIONS.color_accent_loading_secondary_border_50,
    },
    rightAnimationContainer: {
        width: FOUNDATIONS.spacing_250,
        height: '0%',
        top: '0px',
        right: '0px',
        transition: '500ms height',
        position: 'absolute',
        background: FOUNDATIONS.color_accent_loading_secondary_border_50,
    },
    leftAnimationContainer: {
        height: '0%',
        width: FOUNDATIONS.spacing_350,
        bottom: '0px',
        left: '0px',
        transition: '500ms height',
        position: 'absolute',
        background: FOUNDATIONS.color_accent_loading_secondary_border_50,
    },
    borderAnimationContainer: {
        border_radius: FOUNDATIONS.radius_250,
        padding: FOUNDATIONS.spacing_50,
        border: `${FOUNDATIONS.border_50} dashed ${FOUNDATIONS.color_neutral_border_160}`,
        background: FOUNDATIONS.color_neutral_bg_800,
    },
    containerBoxContainer: {
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250}`,
        gap: FOUNDATIONS.spacing_100,
        cursor: 'pointer',
        border: 'none',
        border_radius: FOUNDATIONS.radius_250,
        background: FOUNDATIONS.color_neutral_bg_800,
        position: 'relative',
    },
    containerBoxIcon: {
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
    },
    containerBoxTextsContainer: {
        display: 'flex',
        flex_direction: 'column',
    },
    containerBoxFilename: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_bold,
    },
    containerActionContainer: {
        display: 'flex',
        flex_direction: 'row',
        justify_content: 'space-between',
    },
    actionIcon: {
        display: 'inline',
        margin_right: FOUNDATIONS.spacing_150,
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
    },
    actionIconAndActionTextContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
    },
    containerBoxActionText: {
        display: 'flex',
        flex_direction: 'row',
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        font_weight: FONT_WEIGHT.font_bold,
        text_decoration: TextDecorationType.UNDERLINE,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    containerBoxDescription: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        color: FOUNDATIONS.color_neutral_font_100,
        font_weight: FONT_WEIGHT.font_regular,
    },
});
export const getKubitSelectorBoxFileStyles = (FOUNDATIONS, FONT) => {
    const containerBoxCommonProps = buildContainerBoxCommonProps(FOUNDATIONS, FONT);
    return {
        [KubitSelectorBoxFileVariantType.REGULAR]: {
            states: {
                [SelectorBoxFileStateType.DEFAULT]: {
                    ...containerBoxCommonProps,
                    containerBoxActionText: {
                        ...containerBoxCommonProps.containerBoxActionText,
                        text_decoration: TextDecorationType.NONE,
                    },
                },
                [SelectorBoxFileStateType.LOADING]: {
                    ...containerBoxCommonProps,
                    containerBoxActionText: {
                        ...containerBoxCommonProps.containerBoxActionText,
                        text_decoration: TextDecorationType.NONE,
                    },
                },
                [SelectorBoxFileStateType.SUCCESS]: {
                    ...containerBoxCommonProps,
                    borderAnimationContainer: {
                        ...containerBoxCommonProps.borderAnimationContainer,
                        border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_160}`,
                    },
                },
                [SelectorBoxFileStateType.ERROR]: {},
                [SelectorBoxFileStateType.DISABLED]: {},
            },
        },
    };
};
//# sourceMappingURL=styles.js.map